module.exports = __webpack_public_path__ + "img/banner.4e068818.jpg";